import { format, isThisYear, parseISO } from "date-fns"

export type DateValue = string | Date

function toDate(value: DateValue): Date {
  return typeof value === "string" ? parseISO(value) : value
}

export function formatDateLabel(dateStr: string): string {
  const date = new Date(dateStr)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  const isSameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()

  if (isSameDay(date, today)) return "Today"
  if (isSameDay(date, yesterday)) return "Yesterday"

  return formatShortDate(date)
}

export function formatDate(value: DateValue): string {
  return format(toDate(value), "MMM d, yyyy")
}

export function formatShortDate(value: DateValue): string {
  const date = toDate(value)
  return format(date, isThisYear(date) ? "MMM d" : "MMM d, yy")
}

export function formatMonth(value: DateValue): string {
  return format(toDate(value), "MMM yyyy")
}

export function formatLongMonth(value: DateValue): string {
  return format(toDate(value), "MMMM yyyy")
}

export function formatChartMonth(value: DateValue): string {
  return format(toDate(value), "MMM yy")
}

export function formatDateTime(value: DateValue): string {
  return format(toDate(value), "MMM d · HH:mm")
}

export function formatWeekday(value: DateValue): string {
  return format(toDate(value), "EEE, MMM d")
}

export function formatTimeOfDay(value: DateValue): string {
  return format(toDate(value), "HH:mm")
}

export function localTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function formatTime(value: DateValue): string {
  return format(toDate(value), "h:mm a")
}

export function toDateInputValue(value: DateValue): string {
  return format(toDate(value), "yyyy-MM-dd")
}

export function toDateTimeInputValue(value: DateValue): string {
  return format(toDate(value), "yyyy-MM-dd'T'HH:mm")
}

export function todayInputValue(): string {
  return toDateInputValue(new Date())
}
